import { validateArguments } from "../../visitor";
import { addDivisionValueVisitor as addDivisionValueVisitorFunc, addSubstractionValueVisitor as addSubstractionValueVisitorFunc, addStrictSubtractionValueVisitor as addStrictSubtractionValueVisitorFunc, addMaxValueVisitor as addMaxValueVisitorFunc, addMinValueVisitor as addMinValueVisitorFunc, addSumValueVisitor as addSumValueVisitorFunc, addCountValueVisitor as addCountValueVisitorFunc, addCountValueWithFilterVisitor as addCountValueWithFilterVisitorFunc, addTotalValueVisitor as addTotalValueVisitorFunc, addTotalPercentageToLeafVisitor as addTotalPercentageToLeafVisitorFunc } from "./addCalculatedValueVisitor";
import { addCustomMeasuresVisitor as addCustomMeasuresVisitorFunc } from "./addCustomMeasuresVisitor";
import { addDifferenceVisitor as addDifferenceVisitorFunc } from "./addDifferenceVisitor";
import { addEsgColorIndexVisitor as addEsgColorIndexVisitorFunc } from "./addEsgColorIndexVisitor";
import { addFormattedValueVisitor as addFormattedValueVisitorFunc } from "./addFormattedValueVisitor";
import { addReferenceDateVisitor as addReferenceDateVisitorFunc } from "./addReferenceDateToMeasure";
import { addRepRiskRatingHistoryTooltipDataVisitor as addRepRiskRatingHistoryTooltipDataVisitorFunc } from "./addRepRiskRatingHistoryTooltipDataVisitor";
import { addStaticFieldVisitor as addStaticFieldVisitorFunc } from "./addStaticFieldVisitor";
import { concatenateValuesVisitor as concatenateValuesVisitorFunc } from "./concatenateValuesVisitor";
import { flattenFieldsVisitor as flattenFieldsVisitorFunc } from "./flattenFieldsVisitor";
import { getLeafValuesVisitor as getLeafValuesVisitorFunc } from "./getLeafValuesVisitor";
import { leafToPartialVariationVisitor as leafToPartialVariationVisitorFunc } from "./leafToPartialVariationVisitor";
import { removeIfMissingVisitor as removeIfMissingVisitorFunc } from "./removeIfMissingVisitor";
import { fillMissingMeasuresVisitor as fillMissingMeasuresVisitorFunc } from "./fillMissingMeasuresVisitor";
import { removeIfZeroValueVisitor as removeIfZeroValueVisitorFunc } from "./removeIfZeroValueVisitor";
export var NodesVisitorEnum;
(function (NodesVisitorEnum) {
    NodesVisitorEnum["getLeafValuesVisitor"] = "getLeafValuesVisitor";
    NodesVisitorEnum["leafToPartialVariationVisitor"] = "leafToPartialVariationVisitor";
    NodesVisitorEnum["addTotalPercentageToLeafVisitor"] = "addTotalPercentageToLeafVisitor";
    NodesVisitorEnum["addCustomMeasuresVisitor"] = "addCustomMeasuresVisitor";
    NodesVisitorEnum["addMinValueVisitor"] = "addMinValueVisitor";
    NodesVisitorEnum["addMaxValueVisitor"] = "addMaxValueVisitor";
    NodesVisitorEnum["addSumValueVisitor"] = "addSumValueVisitor";
    NodesVisitorEnum["addCountValueVisitor"] = "addCountValueVisitor";
    NodesVisitorEnum["addCountValueWithFilterVisitor"] = "addCountValueWithFilterVisitor";
    NodesVisitorEnum["addTotalValueVisitor"] = "addTotalValueVisitor";
    NodesVisitorEnum["addDivisionValueVisitor"] = "addDivisionValueVisitor";
    NodesVisitorEnum["flattenFieldsVisitor"] = "flattenFieldsVisitor";
    NodesVisitorEnum["addDifferenceVisitor"] = "addDifferenceVisitor";
    NodesVisitorEnum["addReferenceDateVisitor"] = "addReferenceDateVisitor";
    NodesVisitorEnum["addStaticFieldVisitor"] = "addStaticFieldVisitor";
    NodesVisitorEnum["addSubstractionValueVisitor"] = "addSubstractionValueVisitor";
    NodesVisitorEnum["addStrictSubtractionValueVisitor"] = "addStrictSubtractionValueVisitor";
    NodesVisitorEnum["addFormattedValueVisitor"] = "addFormattedValueVisitor";
    NodesVisitorEnum["addEsgColorIndexVisitor"] = "addEsgColorIndexVisitor";
    NodesVisitorEnum["addRepRiskRatingHistoryTooltipDataVisitor"] = "addRepRiskRatingHistoryTooltipDataVisitor";
    NodesVisitorEnum["concatenateValuesVisitor"] = "concatenateValuesVisitor";
    NodesVisitorEnum["fillMissingMeasuresVisitor"] = "fillMissingMeasuresVisitor";
    NodesVisitorEnum["removeIfMissingVisitor"] = "removeIfMissingVisitor";
    NodesVisitorEnum["removeIfZeroValueVisitor"] = "removeIfZeroValueVisitor";
})(NodesVisitorEnum || (NodesVisitorEnum = {}));
export const NodesVisitors = {
    [NodesVisitorEnum.getLeafValuesVisitor]: {
        visitor: getLeafValuesVisitorFunc
    },
    [NodesVisitorEnum.leafToPartialVariationVisitor]: {
        visitor: leafToPartialVariationVisitorFunc
    },
    [NodesVisitorEnum.addTotalPercentageToLeafVisitor]: {
        visitor: (args) => {
            validateArguments(addTotalPercentageToLeafVisitorFunc.name, 1, args);
            return addTotalPercentageToLeafVisitorFunc(args[0]);
        }
    },
    [NodesVisitorEnum.addCustomMeasuresVisitor]: {
        visitor: (args) => addCustomMeasuresVisitorFunc(args[0])
    },
    [NodesVisitorEnum.addMinValueVisitor]: {
        visitor: (args) => addMinValueVisitorFunc(args)
    },
    [NodesVisitorEnum.addMaxValueVisitor]: {
        visitor: (args) => addMaxValueVisitorFunc(args)
    },
    [NodesVisitorEnum.addSumValueVisitor]: {
        visitor: (args) => addSumValueVisitorFunc(args[0])
    },
    [NodesVisitorEnum.addCountValueVisitor]: {
        visitor: (args) => {
            validateArguments(addCountValueVisitorFunc.name, 1, args);
            return addCountValueVisitorFunc(args[0]);
        }
    },
    [NodesVisitorEnum.addCountValueWithFilterVisitor]: {
        visitor: (args) => {
            validateArguments(addCountValueWithFilterVisitorFunc.name, 2, args);
            return addCountValueWithFilterVisitorFunc(args[0], args[1]);
        }
    },
    [NodesVisitorEnum.addTotalValueVisitor]: {
        visitor: (args) => addTotalValueVisitorFunc(args[0])
    },
    [NodesVisitorEnum.addDivisionValueVisitor]: {
        visitor: (args) => {
            validateArguments(addDivisionValueVisitorFunc.name, 4, args);
            return addDivisionValueVisitorFunc(args[0], args[1], args[2], args[3]);
        }
    },
    [NodesVisitorEnum.flattenFieldsVisitor]: {
        visitor: (args) => flattenFieldsVisitorFunc(args)
    },
    [NodesVisitorEnum.addDifferenceVisitor]: {
        visitor: (args) => addDifferenceVisitorFunc(args)
    },
    [NodesVisitorEnum.addReferenceDateVisitor]: {
        visitor: () => addReferenceDateVisitorFunc()
    },
    [NodesVisitorEnum.addStaticFieldVisitor]: {
        visitor: (args) => addStaticFieldVisitorFunc(args)
    },
    [NodesVisitorEnum.addSubstractionValueVisitor]: {
        visitor: (args) => {
            validateArguments(addSubstractionValueVisitorFunc.name, 3, args);
            return addSubstractionValueVisitorFunc(args[0], args[1], args[2]);
        }
    },
    [NodesVisitorEnum.addStrictSubtractionValueVisitor]: {
        visitor: (args) => {
            validateArguments(addStrictSubtractionValueVisitorFunc.name, 3, args);
            return addStrictSubtractionValueVisitorFunc(args[0], args[1], args[2]);
        }
    },
    [NodesVisitorEnum.addFormattedValueVisitor]: {
        visitor: (args) => {
            validateArguments(addFormattedValueVisitorFunc.name, 4, args);
            return addFormattedValueVisitorFunc(args[0], args[1], args[2], args[3]);
        }
    },
    [NodesVisitorEnum.addEsgColorIndexVisitor]: {
        visitor: (args) => addEsgColorIndexVisitorFunc(args[0])
    },
    [NodesVisitorEnum.addRepRiskRatingHistoryTooltipDataVisitor]: {
        visitor: (args) => addRepRiskRatingHistoryTooltipDataVisitorFunc(args[0])
    },
    [NodesVisitorEnum.concatenateValuesVisitor]: {
        visitor: (args) => {
            validateArguments(concatenateValuesVisitorFunc.name, 2, args);
            return concatenateValuesVisitorFunc(args[0], args[1]);
        }
    },
    [NodesVisitorEnum.removeIfMissingVisitor]: {
        visitor: (args) => removeIfMissingVisitorFunc(args[0], args[1])
    },
    [NodesVisitorEnum.fillMissingMeasuresVisitor]: {
        visitor: (args) => fillMissingMeasuresVisitorFunc(args)
    },
    [NodesVisitorEnum.removeIfZeroValueVisitor]: {
        visitor: (args) => {
            validateArguments(removeIfZeroValueVisitorFunc.name, 1, args);
            return removeIfZeroValueVisitorFunc(args[0]);
        }
    }
};
